exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@font-face{font-family:Kabel Bd;src:url(" + require("./KabelBdNormal.woff2") + ") format(\"woff2\"),url(" + require("./KabelBdNormal.woff") + ") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:Frutiger\\ 57Cn;src:url(" + require("./Frutiger-Cn.woff2") + ") format(\"woff2\"),url(" + require("./Frutiger-Cn.woff") + ") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:SC Gum Kids;src:url(" + require("./SCGumKids.woff2") + ") format(\"woff2\"),url(" + require("./SCGumKids.woff") + ") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:SC Gum Kids;src:url(" + require("./SCGumKids.woff2") + ") format(\"woff2\"),url(" + require("./SCGumKids.woff") + ") format(\"woff\");font-weight:400;font-style:normal}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/assets/fonts/stylesheet.css
// module id = 31
// module chunks = 0